/**
 * Created by fers on 05.02.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import urlMapping from '../app/URLMapping';
import ActivateChannelMutation from './ActivateChannelMutation.react';
import {sendToExtension} from '../app/ExtensionCommunicate';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import AppPanel from '../fw/AppPanel.react';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import "../scenarios/Scenario.scss";
import ScenarioWizard from '../scenarios/ScenarioWizard.react';
import {showJobNotification} from '../app/notification';
import EventTracker from '../app/EventTracker';
import mutationError from '../channel-defs/mutationError';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import {getQueryParams} from '../../common/util/QueryParams';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddStep4.title', 'defaultMessage': 'Editing application'}
});

interface ChannelAddStep5Props {
 createCallback?: (...args: unknown[]) => unknown;
 intl: IntlShape;
 loadingStopFn?: (...args: unknown[]) => unknown;
 relay: object;
 user: User;
 wrapper?: boolean;
}

class ChannelAddStep5 extends React.Component<ChannelAddStep5Props> {

    static propTypes = {
        createCallback: PropTypes.func,
        intl: PropTypes.object.isRequired,
        loadingStopFn: PropTypes.func,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        wrapper: PropTypes.bool
    };

    static defaultProps = {
        wrapper: true
    };

    typeName = 'channels';

    static contextTypes = {
        router: PropTypes.object
    };

    _create = () => {
        return new Promise((resolve, reject) => {
            const channel = this.props.user.organisation.channel;
            const queryParams = getQueryParams(document.location.search);
            const callbackOnSave = queryParams.callbackOnSave;

            let onSuccess = (response) => {
                EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                    event: 'channel-add-success',
                    type: 'application'
                });

                /* inform extension to reload its configuration */
                sendToExtension({
                    message: 'dativery-reload',
                });


                if (response.activateChannel.job) {
                    showJobNotification(this.props.intl, response.activateChannel.job);
                }

                if (this.props.createCallback) {
                    this.props.createCallback(channel);
                }
                /* are we creating this channel as part of scenario? */
                else if (callbackOnSave) {
                    window.location.href = callbackOnSave;
                }
                else if (this.props.user.scenario) {
                    let args = {
                        'organisation_id': this.props.user.organisation['realId'],
                        'scenario_id': this.props.user.scenario['realId'],
                        'urlFragment': this.props.user.scenario['urlFragment'],
                    };

                    let path = urlMapping.getUrl(types['channels'], "scenario-apply", args);
                    this.context.router.push(path);
                } else {
                    let path = urlMapping.getUrl(types['organisations'], "view",  this.props.user.organisation);
                    this.context.router.push(path);
                }

                resolve();
            };
            let onFailure = (transaction) => {
                let error = mutationError(transaction);
                reject(error);
            };

            this.props.relay.commitUpdate(
                new ActivateChannelMutation({
                    channel_id: channel['realId'],
                    organisation_id: this.props.user.organisation['realId']
                }), {onSuccess: onSuccess, onFailure: onFailure}
            );

        });
    };

    componentWillMount() {
        this._create();
    }

    render() {
        if (this.props.wrapper) {
            return null;
        }

        const {channel} = this.props.user.organisation;
        let channelDef = channel.channelDef;
        let type = types['channelDefs'];

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['channels'], data: channel},
                {type: types['scenarios'], data: this.props.user.scenario},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <ScenarioWizard data={this.props.user} step={3} type={type}>
                    <h2><div className="channelAdd-logo"><ChannelIcon channelDef={channelDef} size={128}/></div> {channelDef.name}</h2>
                    <p><FormattedMessage defaultMessage="Your application is ready to be used." id="channel.finish.description" /></p>
                    <LoadingLine withMessage>
                        <FormattedMessage defaultMessage="Activating application…" id="channel.finish.working" />
                    </LoadingLine>
                </ScenarioWizard>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddStep5), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        channelId: '',
        organisationId: '',
        scenarioId: '',
        scenarioSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenario(id: $scenarioId) @include(if: $scenarioSelected) {
                    id,
                    realId,
                    urlFragment,
                    ${ScenarioBoxAsWizard.getFragment('scenario')},
                    ${ScenarioIcon.getFragment('scenario')}
                },
                organisation(id: $organisationId) {
                    id,
                    realId,
                    ${ScenarioBoxAsWizard.getFragment('organisation')},
                    name,
                    channel(id: $channelId) {
                        id,
                        realId,
                        organisation_id,
                        name,
                        activated,
                        channelDef {
                            id,
                            realId,
                            metadata,
                            name,
                            icon
                        }
                    }
                },
            }
        `,
    },
});
